const uploadIcon = `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="41px" viewBox="0 0 48 41" class="upload-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
    <title>cloud-upload</title>
    <desc>Created with Sketch.</desc>
    <g id="Settings-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="DB-Settings--PS--overlay--add" transform="translate(-524.000000, -753.000000)">
            <g id="Group-10-Copy" transform="translate(309.000000, 402.000000)">
                <g id="Group-8" transform="translate(0.000000, 111.000000)">
                    <g id="Group-6" transform="translate(23.000000, 143.000000)">
                        <g id="cloud-upload" transform="translate(192.000000, 91.000000)">
                            <g id="Outline_Icons_1_" transform="translate(0.000000, 6.250000)" stroke="#00A3D9" stroke-linecap="round" stroke-linejoin="round">
                                <g id="Outline_Icons">
                                    <g id="Group">
                                        <path d="M32.9145833,28.1251092 L37.90625,28.1251092 C37.90625,28.1251092 46.875,26.95625 46.875,18.1604167 C46.875,12.5875 42.2729167,8.00625 36.5520833,8.21666667 C34.3166667,3.49583333 29.525,0.227083333 23.9583333,0.227083333 C16.5354167,0.227083333 10.4833333,6.02708333 10.05,13.3395833 C5.4,12.3666667 1.04166667,15.90625 1.04166667,20.65 C1.04166667,28.24375 9.0125,28.1251092 9.0125,28.1251092 L14.9770833,28.1251092" id="Path"></path>
                                        <path d="M23.9583333,16.6666667 L23.9583333,39.5833333" id="Path"></path>
                                        <polyline id="Path" points="30.2083333 22.9166667 23.9583333 16.6666667 17.7083333 22.9166667"></polyline>
                                    </g>
                                </g>
                            </g>
                            <g id="Invisible_Shape">
                                <rect id="Rectangle" x="0" y="0" width="50" height="50"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`;

export default uploadIcon;
